module.exports = __webpack_public_path__ + "static/media/11009867_819873978095797_3196315889432911166_n.54dc7d7b.jpg";